import { render } from "./Order.vue?vue&type=template&id=4447cf86&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=4447cf86&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/kds-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4447cf86"]])

export default __exports__